import axios from "axios";
import { backend_url } from "../constants";

export interface payload {
    supertokensId: string;
    toUpdate: string;
}
export async function updateSeoContent(payload: payload) {
    const result = await axios({
        method: "post",
        url: backend_url,
        data: { ...payload }
    });
    return result.data;
}
